import * as React from 'react';
import { Button, TextField } from '@mui/material';
import { validateLabel } from '../../utils/validationUtils';

// TODO: is withAddButton ever used?
export interface NewFieldProps {
  label: string;
  items: string[];
  width?: number;
  add: (value: string) => void;
  withAddButton?: boolean;
  cypressId?: string;
}

const NewField: React.FC<NewFieldProps> = ({
  label,
  items,
  add,
  width,
  withAddButton,
  cypressId,
}) => {
  const [value, setValue] = React.useState('');
  const [error, setError] = React.useState(false);
  const [helperText, setHelperText] = React.useState('');

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setValue(e.target.value);
  };

  const isValid = () => {
    const validationResult = validateLabel(value, items);
    if (!validationResult.isValid) {
      setHelperText(validationResult.errorMessage);
      setError(true);
      return false;
    } else {
      setHelperText('');
      setError(false);
      return true;
    }
  };

  const saveValue = async () => {
    if (isValid()) {
      try {
        await add(value);
        setValue('');
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleKeyPress = async (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (isValid()) {
        saveValue();
      }
    }
  };

  const handleOnClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    if (isValid()) {
      saveValue();
    }
  };

  return (
    <>
      <TextField
        autoComplete="off"
        error={error}
        fullWidth
        helperText={<span data-cy="new-field-helper-text">{helperText}</span>}
        id="new-field"
        inputProps={{ 'data-cy': cypressId ? cypressId : '' }}
        label={label}
        margin="dense"
        onChange={handleOnChange}
        onKeyPress={handleKeyPress}
        style={{ backgroundColor: 'white', ...(width && { width }) }}
        value={value}
        variant="outlined"
      />
      {withAddButton ? (
        <Button
          variant="contained"
          color="primary"
          style={{ marginLeft: '0.5em' }}
          onClick={handleOnClick}
        >
          Add field
        </Button>
      ) : null}
    </>
  );
};

export default NewField;
